<template>
 <div >
  <vx-card no-shadow class="vx-col lg:w-1/2" style="margin:auto">
    <vs-input class="w-full mb-base" :label-placeholder="$t('OldPassword')" type="password" v-model="password.old_password" />
    <vs-input class="w-full mb-base" :label-placeholder="$t('NewPassword')" type="password" v-model="password.new_password" />
    <!-- <vs-input class="w-full mb-base" label-placeholder="Confirm Password" v-model="confirm_new_password" /> -->

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" @click="ChangePassword">{{$t('SaveChange')}}</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning" @click="Reset">{{$t('Clear')}}</vs-button>
    </div>
  </vx-card>
 </div>
</template>
<script>
export default {
    data(){
        return{
            password:{},
        }
    },
    methods:{
          notifyAlert(color,title,text) {
                this.$vs.notify({ time:8000,
                    fixed:true,
                    color: color,
                    title: title,
                    text: text
                });
                },
        Reset()
        {
            this.password.old_password="";
            this.password.new_password="";
            this.password.mail = "";
        },


    ChangePassword() {
          
        this.password.mail = this.$store.state.AppActiveUser.email;
        this.$store
        .dispatch("auth/ChangePassword", this.password)
        .then(() => {
          this.$vs.notify({
            title: this.$t("success"),
            text: this.$t("PasswordChangedSuccessfully"),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success"
          });
          //  this.notifyAlert("success","success","Password changed successfully");
          this.Reset();
        })
        .catch(res => {
          this.$vs.notify({
            title: this.$t("Error"),
            text: res.response.data.Message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
        });
    }
    }

}
</script>
